import {VideoSlidesStreamBettingRangeDefaultBox} from "./video-slides-stream-betting-range-default.box";

export const VideoSlidesStreamBettingRangeBox = VideoSlidesStreamBettingRangeDefaultBox;
